module.exports = __webpack_public_path__ + "static/media/beyonce.83c70a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/opponent/beyonce.jpg
// module id = 89
// module chunks = 0